export const ITEM_SELECT_TYPE = {
  BUZZ: 'buzz',
  ITEM: 'item',
};
